import { ListItem } from './list-item';
import { ListRoot } from './list-root';

/**
 * Entry point for List.Root and List.Item
 *
 * @since 10.0.0
 */

export const List = {
  Root: ListRoot,
  Item: ListItem,
};
